import { App as NativeApp } from "@capacitor/app";
import { Network } from "@capacitor/network";
import { isNativeApp } from "./runtime";

export const APP_RESUMED_EVENT = "moveinreport:resumed";
export const APP_PAUSED_EVENT = "moveinreport:paused";
export const NATIVE_BACK_EVENT = "moveinreport:back";
let nativeConnected: boolean | undefined;

export function getNativeNetworkStatus(): boolean | undefined {
  return nativeConnected;
}

// Called once at startup. Native listeners live for the lifetime of the app.
export async function initializeNativeLifecycle(): Promise<void> {
  if (!isNativeApp()) return;
  const updateNetwork = (connected: boolean) => {
    nativeConnected = connected;
    window.dispatchEvent(new Event(connected ? "online" : "offline"));
  };
  await Network.addListener("networkStatusChange", (status) => updateNetwork(status.connected));
  await NativeApp.addListener("appStateChange", ({ isActive }) => {
    if (!isActive) {
      window.dispatchEvent(new Event(APP_PAUSED_EVENT));
      return;
    }
    window.dispatchEvent(new Event(APP_RESUMED_EVENT));
    void Network.getStatus().then((status) => updateNetwork(status.connected)).catch(() => undefined);
  });
  updateNetwork((await Network.getStatus()).connected);
}
